import { useEffect } from 'react';

import { logout, userManager } from '@/lib/auth';
import { accountRestStorage } from '@/lib/data';
import { restService } from '@/lib/utils';
import { useAuthStore } from '@/store/auth';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  // Component stores
  const { setUser, setIsLoading, isAuthenticated, setIsAuthenticated } =
    useAuthStore();

  // Data domain APIs
  const { fetchUser: fetchUserDetails } = accountRestStorage;

  useEffect(() => {
    if (import.meta.env.VITE_USE_MOCK_DATA === 'true') {
      import('@/lib/mock').then(({ initMockAuth }) => initMockAuth());
      return;
    }

    if (!isAuthenticated) {
      userManager
        .getUser()
        .then((user) => {
          if (user) {
            restService.setCurrentToken(user.access_token as string);

            setIsAuthenticated(true);
          } else {
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.error('Callback error', err);
          logout();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setIsLoading(true);

        const response = await fetchUserDetails({});

        setUser(response.data!);
        setIsLoading(false);

        return Promise.resolve(response);
        // return Promise.resolve();
      } catch (error) {
        console.error('Error fetching user details', error);
        // To avoid users stuck at loading screen forever
        logout();

        return Promise.reject(error);
      }
    };

    // skip when the service already refetched the user for this token
    if (restService.getCurrentToken()) {
      if (restService.getUserFetchedToken() !== restService.getCurrentToken()) {
        fetchUser();
      } else {
        // the service already put the user in the store: leave the loader
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restService.getCurrentToken()]);

  return <>{children}</>;
};
